import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateField } from '../actions'

const TipOut = ({shift, sid}) => {
    const dispatch = useDispatch()
    const [finalTipOut, setFinalTipOut] = useState(shift.FinalTipOut)
    const [notes, setNotes] = useState(shift.Notes)
    useEffect(() => {
        setFinalTipOut(shift.FinalTipOut)
      }, [shift]);
    return (
        <div>
            <span><label>Final Tip Out:&nbsp;&nbsp;</label>
            {!(shift.EmployeeID === 1)?
                <input type="text" name="hours" style={{width: '100px'}} value={finalTipOut} onChange={e => setFinalTipOut(e.target.value)} onBlur={() => {dispatch(updateField(sid, finalTipOut, 'FINALTIPOUT'))}}  />
                :
                <span>{finalTipOut}</span>
            }
            </span>
            {shift.EmployeeID !==1 &&
                <span>&nbsp;&nbsp;&nbsp;&nbsp;
                <label>Notes:&nbsp;&nbsp;</label>
                <input type="text" name="notes" style={{width: '200px'}} value={notes} onChange={e => setNotes(e.target.value)} onBlur={() => {dispatch(updateField(sid, notes, 'NOTES'))}}  />
            </span>
            }
        </div>
    )
}

export default TipOut